<script setup>
import { validationCheck } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter } from 'vue-router'
const router = useRouter()

import {useOnboarding} from '@store/onboarding'
const $onboarding = useOnboarding()

import Main from './Main.vue'
import BusinessProfileInformation from '../settings/BusinessProfileInformation.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonNext from './ButtonNext.vue'
import { computed, onMounted, watch } from 'vue'

import Prompt from '@utils/Prompt'

const saveGeneralSettings = async () => {
    // validation
    // manually sync this validation with settings/BusinessProfile.vue
    console.log(!$settings.business.name && $settings.addons.staffs)
    let { errors } = validationCheck([
        {
            condition: !$settings.business.full_logo_url,
            message: 'Full logo is required',
        },
        {
            condition: !$settings.business.name && $settings.addons.staffs,
            message: 'Company name is required',
        },
        {
            condition: !$settings.business.type,
            message: `${$settings.addons.staffs ? 'Company' : `${$settings.labels.service?.singular}`} type is required`,
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_first_name,
            message: 'Provider first name is required',
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_last_name,
            message: 'Provider last name is required',
        },
        {
            condition: !$settings.addons.staffs && !$settings.business.provider_display_name,
            message: 'Provider display name is required',
        },

    ])
    if (errors) return

    // await $settings.saveSettings('business', $settings.business)
    // Toast.success('Updated business profile')

    router.push({ name: 'onboarding.business.address' })
}

// onMounted(() => {
//     $settings.fetchSettings()
// })

const backAction = async() => { 
    console.log('$onboarding.isBusinessChanged', $onboarding.isBusinessChanged)
    if(!$onboarding.isBusinessChanged) {
        router.push({ name: 'dashboard' })
        return
    }
    const choice = await Prompt.fire({
        title: 'Unsaved Changes Detected',
        message: `You have unsaved changes. Any unsaved changes will be lost. <br> Are you sure you want to continue?`,
        ok: 'Yes, proceed',
        cancel: 'No, cancel',
    })

    if (choice.ok) {
        router.push({ name: 'dashboard' })
    }
}

const business = computed(() => { 
    return $settings.settings.business
})

// watch(business.value, () => {
//     console.log('$settings.settings.business', business)
//     console.log('settings updated')
//     $onboarding.isBusinessChanged = true
// }, { deep: true })
</script>

<template>
    <Main title="Add Your Business Information" :progress="50" :backButton="backAction">
        <BusinessProfileInformation :provider="!$settings.addons.staffs" />


        <template #footer>
            <!-- <ButtonBack @click="router.push({ name: 'dashboard' })" /> -->
            <ButtonNext text="Continue" @click="saveGeneralSettings()" />
        </template>
    </Main>
</template>